import React, { useEffect, useState } from 'react';
import reqwest from 'reqwest';
import { useParams } from 'react-router-dom';
import settings from '../../../../../settings';

const clientLastNameCache = {};

const readValue = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim();
};

const getClientLastName = (clientData) => {
  if (!clientData) {
    return '';
  }

  if (clientData.ParamName != 'Entry') {
    return '';
  }

  const candidates = [
    clientData.Params.Client?.LastName,
    clientData.Params?.Entry?.LastName,
    clientData.Params?.Client?.Lastname,
    clientData.Params?.Entry?.Lastname,
    clientData.Params?.LastName,
    clientData.Params?.Lastname,
  ];

  return candidates.map(readValue).find((value) => value.length > 0) || '';
};

export const ClientBreadcumbLabel = () => {
  const routeParams = useParams();
  const [lastName, setLastName] = useState('');
  const clientGuid = routeParams?.clientGuid || routeParams?.guid || '';

  useEffect(() => {
    let isMounted = true;

    if (!clientGuid) {
      return () => {
        isMounted = false;
      };
    }

    if (clientLastNameCache[clientGuid]) {
      setLastName(clientLastNameCache[clientGuid]);
      return () => {
        isMounted = false;
      };
    }

    reqwest({
      method: 'get',
      url: settings.clientmanagement.dataContainer.get,
      data: { guid: clientGuid },
    })
      .then((res) => {
        if (!isMounted) {
          return;
        }
        const parsedRes = typeof res === 'string' ? JSON.parse(res) : res;

        if (parsedRes.length > 0) {
          const fetchedLastName = getClientLastName(parsedRes[0]);
          if (fetchedLastName) {
            clientLastNameCache[clientGuid] = fetchedLastName;
            setLastName(fetchedLastName);
          }
        } else {
          const fetchedLastName = getClientLastName(parsedRes);

          if (fetchedLastName) {
            clientLastNameCache[clientGuid] = fetchedLastName;
            setLastName(fetchedLastName);
          }
        }
      })
      .catch(() => {});

    return () => {
      isMounted = false;
    };
  }, [clientGuid]);

  return lastName ? `Klient/in "${lastName}"` : 'Klient/in';
};
